import request from './request'

//用户面试添加
export function getRtcToken() {
  return request({
    url: '/api/rtc/token',
    method: 'get'
  })
}
